import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function LoginForm({ onLogin }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    // Llamamos al backend via LoginPage
    if (onLogin) {
      onLogin({ phone, password }).catch(err => {
        setError(err.message || "Error en el login");
        toast.error(err.message || "Error en el login");
      });
    }
  };

  return (
    <div className="login-widget-container login-bg-abstract">
      <div className="login-widget-abstract-art">
        <img
          src={require('../assets/2.jpg')}
          alt="Arte abstracto profesional"
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '40px 40px 120px 40px/60px 60px 120px 60px' }}
        />
      </div>
      <form className="login-widget-form login-form-ig" onSubmit={handleSubmit}>
        <h2 className="login-widget-title login-title-ig" style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>Turnero</h2>
        <input
          type="text"
          name="phone"
          placeholder="Teléfono WhatsApp"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
          className="login-widget-input login-input-ig"
        />
        <input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="login-widget-input login-input-ig"
        />
        {error && <div style={{ color: "#e50914", fontSize: 14 }}>{error}</div>}
        <button className="login-widget-btn login-btn-ig" type="submit">Ingresar</button>
        <button type="button" className="login-widget-btn login-btn-ig" style={{ background: '#23234a', color: '#fff', marginTop: 8 }} onClick={() => navigate('/register')}>Crear cuenta</button>
      </form>
      <ToastContainer position="top-center" autoClose={1200} hideProgressBar theme="colored" />
    </div>
  );
}
